module.exports = __webpack_public_path__ + "media/images/app/visitors/how-it-works/why-88c409a6026d8c3b0537214da36593ea.webp";